<template>
	<div class="newx_boxx">
		<common-top :commonTopData="commonTopData"></common-top>
	
		<comTable
    :config="tableConfig"
    :filterForm="filterForm"
    ref="table"
    class="tablds"
  >
    <template v-slot:leftBten>
      <el-button
        class="feature-item add"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addFn()"
        >新建内容管理</el-button
      >
    </template>
  </comTable>
	</div> 
 
  
</template>
<script>
import commonTop from '@/components/commonTop.vue'
import comTable from "@/components/firTable.vue";
export default {
  components: {commonTop, comTable },
  data() {
    return {
      commonTopData: {
				"commonleftbtn": [],
			},
      ajaxType2:false,
      ajaxType: false,

      filterForm: [
        {type:'select',label:'厂商',prop:'brand',child:[]},
        {type:'select',label:'状态',prop:'status',child:[
            {name:'待上线',id:'0'},
            {name:'已上线',id:'1'},
            {name:'已下线',id:'-1'}
        ]}
      ],
      tableConfig: {
        url: "fastapptoolBaseAdvList",
        list: [
          { label: "数据ID", prop: "id" },
          { label: "厂商", prop: "brand" },
          {
            label: "ICON",
            prop: "icon",
            type: "img",
            clfn: (da) => {
              return da.icon
                ? `${da.icon}?x-oss-process=image/resize,h_80`
                : "";
            },
          },
          { label: "快游戏名", prop: "app_name" },
          { label: "快游戏包名", prop: "package" },
          { label: "dp link", prop: "dp_link",width:200,type:'html',clfn:da=>{
            return `<div style="max-height: 75px;overflow: hidden;overflow-y: auto;"><span>${da.dp_link}</span><div>`
          }},
          {
            label: "广告素材",
            prop: "adv_material_pic",
            type: "img",
            clfn: (da) => {
              return da.adv_material_pic
                ? `${da.adv_material_pic}?x-oss-process=image/resize,h_50`
                : "";
            },
          },
          { label: "广告素材标题", prop: "adv_title" },
         
          {
            label: "状态",
            prop: "status",
            type: "html",
            clfn: (da) => {
              let mpd = {
                '0':{name:'待上线',color:'#000'},
                '1':{name:'已上线',color:'#2dc72d'},
                '-1':{name:'已下线',color:'red'}
              }
              let po = mpd[da.status];

              return `<span style="color:${po?po.color:''};">${po?po.name:''}</span>` 
            }
          },


          { label: "更新时间",width:100, prop: "update_at" },
          {
            label: "操作",
            type: "tool",
            btns: [
              {label: "编辑",clickFn:(da)=>{
                localStorage.setItem('kyysetData',JSON.stringify(da))
                this.$router.push("/art/baseAdvAdd?type=edit");
              }},
              {
                label: "下架",backLabel:da=>{
                  return da.status == 1 ? '下架': '上架'
                },
                clickFn: this.dgxj,
              },

              {
                label: "删除",
                clickFn: (da) => {
                  this.handleDel(da);
                },
              },
            ],
          },
        ],

      },
    };
  },


  mounted(){
    this.getBrand((da)=>{
      this.filterForm[0].child =  da.map(e=>{
        return {name:e,id:e}
      })
    })
  },
  methods: {
    
    addFn() {
      this.$router.push("/art/baseAdvAdd?type=add");
    },
    selectedDatafn(da) {
      this.checKData = da;
    },
    handleDel(row) {
      if (this.ajaxType) {
        this.$message("正在处理请稍后");
        return;
      }
      this.$confirm(
        `是否将选中内容删除？`,
        "内容删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {

          this.ajaxType = true;
          this.api
          .fastapptoolDelBaseAdv({
            id: row.id,
          })
          .then((res) => {
            this.ajaxType = false;
            if (!res) return;
            this.$message.success("删除成功");
            this.$refs.table.getData();
          })
          .catch(() => {
            this.ajaxType = false;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dgxj(da) {
      if(da.status!=1){
        this.deltFN2({
          id:da.id,
          status:'1',
        })
        return
      }
      this.xjFn(da);
    },
    xjFn(da) {
      if (this.ajaxType2) {
        this.$message("正在处理请稍后");
        return;
      }
      this.$confirm(
        `是否确认将选中内容下架？`,
        '下架',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {

        this.deltFN2({
          id:da.id,
          status:'-1'
        });
      });
    },
    deltFN2(pr) {
      this.ajaxType2 = true;
      this.api
        .fastapptoolShelfBaseAdv(pr)
        .then((res) => {
          this.ajaxType2 = false;
          if (!res) return;
          this.$message.success("操作成功");
          this.$refs.table.getData();
        })
        .catch(() => {
          this.ajaxType2 = false;
        });
    },

  },
};
</script>
<style lang='scss' scoped>
.newx_boxx{
  height: 100%;
}
.tablds{
  height: calc(100% - 75px);
}
</style>